import { ImportFile } from './import-file';

export class LearnerImport extends ImportFile {
  constructor(data) {
    super(data);
    this.checkingAssignPackageId = data.checkingAssignPackageId;
  }
}
